import { useState } from "react";
import { plotStatusIds, PropertyTypeList } from "../../../Enum";
import AsteriskStyle from "../../../components/Form/Tooltip/AsteriskStyle";
import { getIcons } from "../../../components/Constant/Constant";
import CustomSelect from "../../../components/common/CustomSelect";
import ConfirmationModal from "../../../components/shareableContainer/ConfirmationModal";

const AutoPopulateProperty = ({
  isOpen,
  onClose,
  unit,
  isSliderOpen,
  onHide,
  handleChange,
  handleSave,
  handleCancel,
  isNew = false,
  propertySaleType,
}) => {
  const icons = getIcons();
  const [isModel, setIsModel] = useState(false);
  const [pendingStatusId, setPendingStatusId] = useState(null);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictCount, setConflictCount] = useState(2); 

  const isEditStatus = unit?.statusName !== "Available" ? false : true;

  const handelConfirmStatus = () => {
    handleChange({
      target: { name: "unitStatus", value: pendingStatusId },
    });
    setIsModel(false);
  };

  const handleConflictAction = (action) => {
    if (action === "addQuery") {
     
      console.log("Adding as query");
    } else if (action === "ignore") {
   
      console.log("Ignoring conflict");
    }
    setShowConflictModal(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-[10px] shadow-xl w-[100%] p-6 transform transition-all">
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <div
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            <div className="bg- cursor-pointer flex items-center justify-center gap-2 text-base text-customGreen font-medium s w-full rounded-[10px] p-2">
              <div>{"Auto Upload"}</div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-red-600 bg-white px-2 focus:outline-none rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {conflictCount > 0 && (
          <div className="flex justify-end mb-4">
            <button
              onClick={() => setShowConflictModal(true)}
              className="border-orange-500 border text-orange-500 px-3 py-1 rounded-md flex items-center"
            >
              <span>Conflict: {conflictCount}</span>
              
            </button>
          </div>
        )}
        <div className="grid grid-cols-3 gap-5 p-4  h-[500px] overflow-y-auto">
         <div className="flex flex-col gap-5"> 


         <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Property Type
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={PropertyTypeList.map((list) => ({
                  value: list.id,
                  label: list.label,
                }))}
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Property No / Extent
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="propertyNo"
                disabled={isEditStatus}
                value={unit?.propertyNo || ""}
                onChange={handleChange}
                maxLength={40}
                className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                placeholder="Property No / Extent"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Overall Sqft
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="sqft"
                value={unit?.sqft === 0 ? "" : unit?.sqft}
                min={1}
                disabled={isEditStatus}
                max={999}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^\d{0,10}(\.\d{0,2})?$/;
                  if (
                    value === "" ||
                    (regex.test(value) && Number(value) >= 0)
                  ) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Square Feet"
              />
            </div>
          </div>


          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Village Name
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="villageName"
                value={unit?.villageName || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="TEXT"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              SRO
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="sro"
                value={unit?.sro || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="TEXT"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Per Cent / Ground Price
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="perCentGroundPrice"
                value={
                  unit?.perCentGroundPrice === 0 ? "" : unit?.perCentGroundPrice
                }
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Per Cent / Ground Price"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Over All Minimum Budget
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="overallMinBudget"
                value={
                  unit?.overallMinBudget === 0 ? "" : unit?.overallMinBudget
                }
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Over All Minimum Budget"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Over All Max Budget
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="overallMaxBudget"
                value={
                  unit?.overallMaxBudget === 0 ? "" : unit?.overallMaxBudget
                }
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Over All Max Budget"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Status
              <AsteriskStyle />
            </label>
            <div className="col-span-8 relative">
              <select
                name="unitStatus"
                value={unit?.unitStatus?.id}
                disabled={isEditStatus}
                onChange={(e) => {
                  setPendingStatusId(e.target.value);
                  setIsModel(true);
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none bg-gray-50"
              >
                {plotStatusIds.map((status) => (
                  <option key={status.value} value={status.id}>
                    {status.label}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
              Assign Responsible Person
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <CustomSelect
                  options={PropertyTypeList.map((list) => ({
                    value: list.id,
                    label: list.label,
                  }))}
                />
              </div>
            </div>
    

          <div className="grid grid-cols-12 items-center">
          <label className="col-span-4 text-sm font-medium text-gray-700">
              Notes

            </label>
            <div className="col-span-8">

              <textarea
                type="text"
                name="notes"
                maxLength={250}
                disabled={isEditStatus}
                value={unit?.notes || ""}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
              />
            </div>
          </div>

         </div>


         <div className="flex flex-col gap-5"> 



         <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Property Name
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="unitNo"
                disabled={isEditStatus}
                value={unit?.unitNo || ""}
                onChange={handleChange}
                maxLength={40}
                className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                placeholder="Unit Number"
              />
            </div>


          </div>
         
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Plot Sourced by
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="plotSourcedBy"
                disabled={isEditStatus}
                value={unit?.plotSourcedBy || ""}
                onChange={handleChange}
                maxLength={40}
                className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                placeholder="Name"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Road Facing
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="roadFacing"
                value={unit?.roadFacing || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
              />
            </div>
          </div>

               
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Land Mark
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="landMark"
                value={unit?.landMark || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="TEXT"
              />
            </div>
          </div>
         
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Survey No
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="surveyNo"
                value={unit?.surveyNo || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="TEXT"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Budget
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="budget"
                value={unit?.budget === 0 ? "" : unit?.budget}
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Budget"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              LC
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="lc"
                value={unit?.lc || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="LC"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Guideline
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="guideline"
                value={unit?.guideline || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Guideline"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Document Type
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="documentType"
                value={unit?.documentType || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={50}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Document Type"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              ROI
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="roi"
                value={unit?.roi === 0 ? "" : unit?.roi}
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="ROI"
              />
            </div>
          </div>
         

         </div>

         <div className="flex flex-col gap-5"> 



         <div className="grid grid-cols-12">
            <label className="col-span-4 text-sm font-medium text-gray-700 mt-2">
              Dimension{" "}
              <span className="text-xs text-customGreen">(In Feet)</span>
              <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <div className="relative w-full h-72 bg-gray-50 rounded-md border flex items-center justify-center p-4">
                <div className="w-36 h-36 border-4 rounded-md border-customGreen flex flex-col justify-between items-center">
                  <input
                    type="text"
                    value={unit?.northDimension || ""}
                    disabled={isEditStatus}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 10) {
                        handleChange({
                          target: { name: "northDimension", value },
                        });
                      }
                    }}
                    className="absolute top-9 left-1/2 transform -translate-x-1/2 -translate-y-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                    placeholder="FT"
                    maxLength={10}
                  />
                  <input
                    type="text"
                    value={unit?.southDimension || ""}
                    disabled={isEditStatus}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 10) {
                        handleChange({
                          target: { name: "southDimension", value },
                        });
                      }
                    }}
                    className="absolute bottom-9 left-1/2 transform -translate-x-1/2 translate-y-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                    placeholder="FT"
                    maxLength={10}
                  />
                  <input
                    type="text"
                    value={unit?.westDimension || ""}
                    disabled={isEditStatus}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 10) {
                        handleChange({
                          target: { name: "westDimension", value },
                        });
                      }
                    }}
                    className="absolute left-9 top-1/2 transform -translate-y-1/2 -translate-x-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                    placeholder="FT"
                    maxLength={10}
                  />
                  <input
                    type="text"
                    value={unit?.eastDimension || ""}
                    disabled={isEditStatus}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 10) {
                        handleChange({
                          target: { name: "eastDimension", value },
                        });
                      }
                    }}
                    className="absolute right-9 top-1/2 transform -translate-y-1/2 translate-x-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                    placeholder="FT"
                    maxLength={10}
                  />
                  <div className="text-xs font-medium text-gray-700 mt-2">
                    North
                  </div>
                  <div className="flex justify-between w-full px-4">
                    <div className="text-xs font-medium text-gray-700">
                      West
                    </div>
                    <div className="text-xs font-medium text-gray-700">
                      East
                    </div>
                  </div>
                  <div className="text-xs font-medium text-gray-700 mb-2">
                    South
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Market Rate Per Sq.Ft
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="marketRatePerSqft"
                value={
                  unit?.marketRatePerSqft === 0 ? "" : unit?.marketRatePerSqft
                }
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Market Rate Per Sq.Ft"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              DAYS
            </label>
            <div className="col-span-8">
              <input
                type="number"
                name="days"
                value={unit?.days === 0 ? "" : unit?.days}
                disabled={isEditStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,5}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                min={0}
                max={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="DAYS"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Plot Photos & Videos
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="plotPhotosVideos"
                value={unit?.plotPhotosVideos || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={100}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Plot Photos & Videos"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Location Map Link
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="locationMapLink"
                value={unit?.locationMapLink || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={100}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Location Map Link"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Sketch Link
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="sketchLink"
                value={unit?.sketchLink || ""}
                disabled={isEditStatus}
                onChange={handleChange}
                maxLength={100}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Sketch Link"
              />
            </div>
          </div>

         </div>
      
     
  
      
         
   


          {!isEditStatus && (
            <div className="mt-6">
              <button
                onClick={handleSave}
                className="w-full py-3 bg-customGreen text-white rounded-md hover:bg-customGreen focus:outline-none font-medium"
              >
                Done
              </button>
            </div>
          )}
        </div>
      </div>

      <ConfirmationModal
        showModal={isModel}
        title="Change Unit Status"
        message="Are you sure you want to change the unit status?"
        onConfirm={handelConfirmStatus}
        onCancel={() => {
          setIsModel(false);
          setPendingStatusId(null);
        }}
      />

      {showConflictModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-[10px] shadow-xl w-[400px] p-6">
            <h2 className="text-lg font-medium text-gray-700 mb-4">Conflict Detected</h2>
            <p className="text-sm text-gray-600 mb-4">There are {conflictCount} conflicts. What would you like to do?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => handleConflictAction("ignore")}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
              >
                Ignore
              </button>
              <button
                onClick={() => handleConflictAction("addQuery")}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              >
                Add as Query
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoPopulateProperty;